<template>
    <div class="menu-adjustment" :class="{ 'pr-5': isEpicVaultEnabled && showMultiAssociationLink }">
        <div class="block py-1 px-2 align-middle" data-cy="nav-association-name" v-if="!showMultiAssociationLink">
            <span class="text-base text-right mt-2 font-semibold pr-5">
                {{ currentAssociation }}
            </span>
        </div>
        <a-dropdown :placement="'bottomRight'" :trigger="['click']" v-if="showMultiAssociationLink">
            <span
                class="multi-menu inline-block pt-3 pb-2 px-2 align-middle no-underline border-b-2 border-white cursor-pointer"
                :class="{ claimsvault: displayClaimsColor }"
                data-cy="nav-association-name"
            >
                <span class="text-base text-right font-semibold">
                    {{ currentAssociation }}
                    <DownOutlined />
                </span>
            </span>
            <template #overlay>
                <a-menu @click="handleAssociationChange">
                    <template v-for="association_item in multiAssociationList" :key="association_item.id">
                        <a-menu-item>
                            {{ association_item.name }}
                        </a-menu-item>
                    </template>
                </a-menu>
            </template>
        </a-dropdown>
    </div>
</template>

<script>
import User from '@/models/user.js';
import { DownOutlined } from '@ant-design/icons-vue';

export default {
    components: {
        DownOutlined,
    },
    computed: {
        currentAssociation() {
            return this.$store.getters['user/currentAssociationName'];
        },
        showMultiAssociationLink() {
            return this.$store.getters['user/isMultiAssociation'];
        },
        multiAssociationList() {
            return this.$store.getters['user/multiAssociationList'];
        },
        isEpicVaultEnabled() {
            return this.is_epic_vault_enabled ? true : false;
        },
        displayClaimsColor() {
            return (
                (this.isEpicVaultEnabled && this.$store.state.navigation.current_link === 'claim') ||
                !this.isEpicVaultEnabled
            );
        },
    },
    props: {
        is_epic_vault_enabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        handleAssociationChange({ key }) {
            User.changeAssociation(key);
        },
    },
};
</script>
